export enum GroupRouteName {
    Index = 'system.groups.index',
    Create = 'system.groups.create',
    Edit = 'system.groups.edit',
}

export default {
    path: 'groups',
    name: GroupRouteName.Index,
    component: () => import('@/views/system/groups/Index.vue'),
    meta: {
        auth: true,
        label: 'Groups',
        icon: 'fal fa-object-group fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-groups',
    },
    children: [
        {
            path: 'create',
            name: GroupRouteName.Create,
            component: () => import('@/views/system/groups/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Group',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-groups',
            },
        },
        {
            path: ':groupId/edit',
            name: GroupRouteName.Edit,
            component: () => import('@/views/system/groups/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Group',
                icon: 'fal fa-folder-tree fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-groups',
            },
        },
    ],
}
